import { Component, Element, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'pn-marketweb-siteheader-unified-login',
  styleUrl: 'pn-marketweb-siteheader-unified-login.scss',
})
export class PnMarketwebSiteheaderUnifiedLogin {
  @Element() hostElement: HTMLElement;
  @Prop() loggedIn: boolean = false;
  @Prop() logInLabel: string;
  @Prop() useMarketwebLogin: boolean;
  @Prop() environment: string;

  render() {
    return (
      <Host>
          <pn-marketweb-siteheader-login-button 
              label={this.logInLabel} 
              useMarketwebLogin={this.useMarketwebLogin} 
              environment={this.environment}
              />
      </Host>
    );
  }
}
